import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { execute } from '@tutorabc/webview-jsbridge'
import { CSSProperties } from 'react'

// Libs
import handleLocationHrefDirect from '@/methods/url/handleLocationHrefDirect'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Components
import Icon from '@/assets/icons'
import AdaptiveButton from '@/components/common/AdaptiveButton'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'
import { BRIDGE_HANDLER } from '@/constants/bridgeHandler'
import { isClientSideShopApp } from '@/utils/navigator'
import { isLiveMallClub } from '@/constants/systemType'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface EmptyProps {
  icon?: React.ReactNode
  title?: string
  description?: string
  hiddenButton?: boolean
  buttonText?: string
  buttonUrl?: string
  isExternalLink?: boolean
  style?: CSSProperties
  openLineApp?: boolean
}

const Empty = (props: EmptyProps) => {
  const router = useRouter()
  const { t } = useTranslation()

  const {
    icon = <Icon.Empty />,
    title = t('Empty_Default_Title'),
    description = t('Empty_Default_Description'),
    hiddenButton = false,
    buttonText = t('Empty_Default_Button_Text'),
    buttonUrl = isLiveMallClub ? ROUTE_PATH.EXPLORE : ROUTE_PATH.MALL,
    isExternalLink = false,
    style,
    openLineApp,
  } = props

  const handleButtonClick = () => {
    if (isLiveMallClub) {
      handleRoutePushWithQuery({ router, pathname: buttonUrl })
      return
    } else if (isClientSideShopApp && !isExternalLink) {
      execute({
        handlerName: BRIDGE_HANDLER.GO_SHOP,
      })
      return
    } else if (openLineApp) {
      execute({
        handlerName: BRIDGE_HANDLER.OPEN_LINE_OFFICIAL_ACCOUNT,
      })
      return
    }

    isExternalLink
      ? handleLocationHrefDirect({ router, url: buttonUrl, isOpen: !isClientSideShopApp })
      : handleRoutePushWithQuery({ router, pathname: buttonUrl })
  }

  return (
    <div className={cx('empty', { isLiveMallClub })} style={style}>
      <div className={cx('empty-icon', { isLiveMallClub })}>{icon}</div>
      <div className={cx('empty__content')}>
        <h4 className={cx('empty__content-title')}>{title}</h4>
        <h4 className={cx('empty__content-description')}>{description}</h4>
      </div>
      {!hiddenButton && (
        <AdaptiveButton size={isLiveMallClub ? 'md' : 'sm'} onClick={handleButtonClick} style={isLiveMallClub ? { width: 'fit-content' } : undefined}>
          {buttonText}
        </AdaptiveButton>
      )}
    </div>
  )
}

export default Empty
